import { render, staticRenderFns } from "./airQuality.vue?vue&type=template&id=67974fd4&scoped=true"
import script from "./airQuality.vue?vue&type=script&lang=js"
export * from "./airQuality.vue?vue&type=script&lang=js"
import style0 from "./airQuality.vue?vue&type=style&index=0&id=67974fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67974fd4",
  null
  
)

export default component.exports